/* eslint-disable react/jsx-props-no-spreading */
import React, { SVGProps } from 'react';

const InsuranceFund = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={26}
    height={26}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="InsuranceFund">
    <g clipPath="url(#insuranceFund)" stroke="var(--secondaryBackground)">
      <path
        d="M15.167 9.75V4.333h-9.75v17.334h6.56c.356.451.785.85 1.279 1.175l1.505.991H4.326A1.076 1.076 0 0 1 3.25 22.76V3.24c0-.581.486-1.074 1.085-1.074h11.912l6.503 6.5V9.75h-7.583ZM13 11.917h9.75v6.444a3.198 3.198 0 0 1-1.447 2.67l-3.428 2.259-3.428-2.258A3.199 3.199 0 0 1 13 18.362v-6.445Zm2.167 6.444c0 .343.175.666.472.862l2.236 1.473 2.236-1.473a1.033 1.033 0 0 0 .472-.862v-4.278h-5.416v4.278Z"
        fill="var(--quicklinkIcon)"
      />
      <path
        d="M13 11.917h9.75v6.444a3.198 3.198 0 0 1-1.447 2.67l-3.428 2.259-3.428-2.258A3.199 3.199 0 0 1 13 18.362v-6.445Zm2.167 6.444c0 .343.175.666.472.862l2.236 1.473 2.236-1.473a1.033 1.033 0 0 0 .472-.862v-4.278h-5.416v4.278Z"
        fill="var(--quicklinkIcon)"
      />
    </g>
    <defs>
      <clipPath id="insuranceFund">
        <path fill="#fff" d="M0 0h26v26H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default InsuranceFund;
